// eslint-disable-next-line
import { Button } from 'baby-design'
import { shopRegistryPath, storePath } from 'lib/urls'
import classNames from 'classnames'
import { useTracking } from 'lib/analytics'
import {
  trackRegDiscountBrowseShopLinkClick,
  trackRegDiscountShopYourRegistryLinkClick,
} from 'src/routes/(shop)/lib/tracking'
import css from './Button.styles.scss'

interface ButtonContainerProps {
  children: React.ReactNode
}

const ButtonContainer = ({ children }: ButtonContainerProps) => (
  <div className={css.Button__container}>{children}</div>
)

export const ShopYourRegistryButton = () => {
  const { trackEvent } = useTracking()

  return (
    <ButtonContainer>
      <Button
        className={classNames(css.Button, [css[`Button--wide`]])}
        href={shopRegistryPath}
        size="lg"
        variant="primary"
        onClick={() => trackRegDiscountShopYourRegistryLinkClick(trackEvent)}
      >
        Shop your registry
      </Button>
    </ButtonContainer>
  )
}

export const BrowseShopButton = () => {
  const { trackEvent } = useTracking()

  return (
    <ButtonContainer>
      <Button
        className={classNames(css.Button, [css[`Button--wide`]])}
        href={storePath}
        size="lg"
        variant="secondary"
        onClick={() => trackRegDiscountBrowseShopLinkClick(trackEvent)}
      >
        Browse Babylist Shop
      </Button>
    </ButtonContainer>
  )
}

export const AddItemFromShopButton = () => (
  <ButtonContainer>
    <Button
      className={classNames(css.Button, [css[`Button--wide`]])}
      href={storePath}
      size="lg"
      variant="primary"
    >
      Add items from Babylist Shop
    </Button>
  </ButtonContainer>
)
